const emailVerification = {
  title: "Staðfesting netfangs",
  notice: {
    title: "Staðfestingar krafist",
    sentTo: "6 stafa staðfestingarkóði hefur verið sendur á:",
  },
  form: {
    codeLabel: "Staðfestingarkóði:",
    codePlaceholder: "000000",
    codeHint: "Sláðu inn 6 stafa kóðann úr tölvupóstinum þínum",
  },
  resendSuccess: "Staðfestingarkóði endursendur!",
  verifying: "Staðfesti...",
  verify: "Staðfesta netfang",
  resending: "Sendi...",
  resendCode: "Endursenda kóða",
  help: {
    title: "Fékkstu ekki kóðann?",
    checkSpam: "Athugaðu ruslpóstmöppuna þína",
    checkEmail: "Gakktu úr skugga um að netfangið sé rétt",
    clickResend: "Smelltu á „Endursenda kóða“ til að reyna aftur",
    contactAdmin: "Hafðu samband við kerfisstjóra ef vandinn er viðvarandi",
  },
  errors: {
    invalidCode: "Vinsamlegast sláðu inn 6 stafa staðfestingarkóða",
    verificationFailed: "Staðfesting mistókst",
    resendFailed: "Ekki tókst að endursenda kóða",
  },
};

export default emailVerification;
